import { API_URL } from '@/env'
import { routes } from '@/pages'
import axios, { AxiosRequestConfig } from 'axios'

export const LOCAL_STORAGE_KEY_JWT = 'jwt'

const client = axios.create({ baseURL: API_URL })

client.interceptors.request.use((config) => {
  try {
    if (config.headers?.Authorization !== undefined) {
      return config
    }
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_JWT) || '')

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  } catch (error) {
    console.error('Error reading token', error)
  }

  return config
})

client.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(LOCAL_STORAGE_KEY_JWT)
      window.location.replace(routes.login.path)
    }
    if (
      error.response?.status === 403 &&
      error.response?.data?.error === 'You are not allowed to access this resource'
    ) {
      localStorage.removeItem(LOCAL_STORAGE_KEY_JWT)
      window.location.replace(routes.ban.path)
    }
    return Promise.reject(error)
  }
)

export const api = {
  get: <T>(url: string, config?: AxiosRequestConfig): Promise<T> => client.get(url, config).then(({ data }) => data),
  post: <T>(url: string, data?: unknown, config?: AxiosRequestConfig<unknown>): Promise<T> =>
    client.post(url, data, config).then(({ data }) => data),
  put: <T>(url: string, data?: unknown): Promise<T> => client.put(url, data).then(({ data }) => data),
  patch: <T>(url: string, data?: unknown): Promise<T> => client.patch(url, data).then(({ data }) => data),
  delete: <T>(url: string): Promise<T> => client.delete(url).then(({ data }) => data)
}
